module.exports = __webpack_public_path__ + "img/front-logo.9460805a.png";